export default __webpack_public_path__ + "static/media/logo.abb10392.png";